import cn from 'classnames'
import Link from 'next/link'
import React from 'react'

import { ProductsSolutionsCarousel } from '../ProductsSolutionsCarousel/ProductsSolutionsCarousel'
export interface SolutionViewProps {
  topicId?: string
  subTopicId?: string
  url?: string
  type?: string
}

export const SolutionView: React.FC<SolutionViewProps> = (props) => {
  return (
    <div className={cn('w-full px-5 sm:px-0 flex flex-row justify-center bg-white')}>
      <div className="max-w-screen-xl w-full">
        <p className="font-bold w-full text-left mt-10 text-[1.5rem] mb-4">Products and Solutions</p>
        <ProductsSolutionsCarousel topicId={props.topicId} subTopicId={props.subTopicId} type={props.type} />
        <Link
          href={props.url || ''}
          className="font-bold w-full text-center mt-3 cursor-pointer text-textdark underline underline-offset-4"
        >
          View Full Directory
        </Link>
      </div>
    </div>
  )
}
